import { Box, Chip } from "@mui/material";
import { ReactNode } from "react";

import { CustomerContactDto } from "@/core/api/generated/v1";

import AppPopover from "../../Popover/AppPopover";
import AppPopoverContent from "../../Popover/AppPopoverContent";

interface Props {
  contact: CustomerContactDto | null | undefined;
  popoverContent?: ReactNode;
}

export default function CustomerContactChip({ contact, popoverContent }: Props) {
  if (!contact) {
    return null;
  }

  return (
    <AppPopover
      enabled={!!popoverContent}
      hoverBehavior={{}}
      trigger={
        <Box>
          <Chip
            variant='filled'
            color='default'
            size='medium'
            sx={{ minWidth: "32px" }}
            label={<Box>{contact.personName?.name || contact.email}</Box>}
          />
        </Box>
      }
    >
      <AppPopoverContent>{popoverContent}</AppPopoverContent>
    </AppPopover>
  );
}
